export enum PublicationType {
    Continous = 1, //todo: fix typo
    TimeLimited = 2,
}
